import React, { useEffect, useState } from 'react';
import { Grid } from '@mui/material';
import { useDispatch, useSelector } from 'react-redux';
import { getFaqSection } from 'redux/actions/UserFAQ';
import CommonBreadCrumb from 'components/commonBreadCrumb/CommonBreadCrumb';
import FaqTabSection from './FaqTabSection';
import { useNavigate, useParams } from 'react-router-dom';


function FAQ() {
  const navigate = useNavigate();
  const { tabs } = useParams();
  const [value, setValue] = useState(tabs || 'Customer');
  const dispatch = useDispatch();
  const faqSection = useSelector((state) => state?.userFaqSection?.userFaqSection?.data);
  const faqSectionLoader = useSelector((state) => state?.userFaqSection?.loading)
  useEffect(()=>{
    dispatch(getFaqSection()); 
  },[]) 
  const breadcrumbPaths = [
    { name: 'FAQ', url: '', className:'colorPrimary' ,},
  ];

  const handleChange = (event, newValue) => {
    navigate(`/configuration/faq/${newValue}`);
    setValue(newValue);
    if (newValue === 'Customer') {
      dispatch(getFaqSection())
    }
    else {
      dispatch(getFaqSection())
    }


  };
  return (
  
    <Grid container>
      <CommonBreadCrumb paths={breadcrumbPaths}/>
      <FaqTabSection 
      accordianData={faqSection} 
      handleChange={handleChange} 
      value={value} 
      faqSectionLoader={faqSectionLoader} 
      /> 
    </Grid>
  )
}

export default FAQ;